import { createHydratableStore } from "./createHydratableStore";

export type AdGroupNameFormValues = {
  adGroupName: string;
  [key: string]: unknown;
};

export const useAdGroupNameStore = createHydratableStore<AdGroupNameFormValues>({
  adGroupName: "",
});
